export default __webpack_public_path__ + "static/media/icon-bronze.659a6307.svg";